<!-- Define our page card. -->
<mat-card class="mat-page-card">

  <!-- Define the header of our page card. -->
  <mat-card-header>

    <!-- Give our page an icon. -->
    <mat-icon mat-card-avatar color="icon-orange">shield_person</mat-icon>

    <!-- Give our page a main title. -->
    <mat-card-title>
      Administrator Management
    </mat-card-title>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle>Below is a table of the existing administrators in the system along with their management
      actions.
    </mat-card-subtitle>
  </mat-card-header>

  <!-- Define the content of our page card. -->
  <mat-card-content>
    <div>
      <table mat-table [dataSource]="administrators" class="mat-elevation-z8">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="_select">
          <th mat-header-cell *matHeaderCellDef>

            <!-- Define our select-all checkbox --
            <mat-checkbox #chkToggleAllAdministrators
                          (change)="toggleAllAdministratorsSelection(chkToggleAllAdministrators.checked)"></mat-checkbox> -->
          </th>
          <td mat-cell *matCellDef="let element">
            <!-- <mat-checkbox (change)="toggleAdministratorSelection(element, $event.checked)"
                          [checked]="element.selected"
                          [disabled]="currentAdministrator.emailAddress === element.emailAddress"></mat-checkbox> -->
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Email Address Column -->
        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef>Email Address</th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <span *ngIf="element.emailAddress === currentAdministrator.emailAddress" matBadge="!"
                  matBadgeColor="warn"
                  matBadgeDescription="This is you.  You can't modify your own account from this page."
                  matBadgeOverlap="false"
                  matBadgeSize="small"
                  matTooltip="This is you.  You can't modify your own account from this page.">{{ element.emailAddress }}</span>
            <span *ngIf="element.emailAddress !== currentAdministrator.emailAddress">{{ element.emailAddress }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let a">{{ a.firstName }} {{ a.lastName }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let a;">

            <!-- Display the lock icon if the administrator is locked. -->
            <span *ngIf="a.locked">
              <mat-icon class="mat-icon-red" matTooltip="Administrator is currently Locked.">lock</mat-icon>
              &nbsp;
            </span>

            <!-- Display the unlock icon if the administrator is not locked. -->
            <span *ngIf="!a.locked">
              <mat-icon class="mat-icon-green" matTooltip="Administrator is currently Unlocked.">lock_open</mat-icon>
              &nbsp;
            </span>

            <!-- Display the cloud_done icon if the administrator is online. -->
            <span *ngIf="a.online">
              <mat-icon class="mat-icon-green" matTooltip="Administrator is currently Online.">cloud_done</mat-icon>
              &nbsp;
            </span>

            <!-- Display the cloud_off icon if the administrator is offline. -->
            <span *ngIf="!a.online">
              <mat-icon class="mat-icon-slate" matTooltip="Administrator is currently Offline.">cloud_off</mat-icon>
              &nbsp;
            </span>

            <!-- Display the key icon if the administrator password needs to be changed. -->
            <span *ngIf="a.passwordExpires && a.passwordPromptForChange">
              <mat-icon class="mat-icon-red" matTooltip="Administrator needs a Password Reset.">vpn_key</mat-icon>
            </span>
          </td>
        </ng-container>

        <!-- Created Column -->
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let a;">{{ a.created | date: 'medium' }}</td>
        </ng-container>

        <!-- Modified Column -->
        <ng-container matColumnDef="modified">
          <th mat-header-cell *matHeaderCellDef>Modified</th>
          <td mat-cell *matCellDef="let a;">{{ a.updated | date: 'medium' }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="_actions">

          <!-- Add Administrator -->
          <th mat-header-cell *matHeaderCellDef class="align-end">
            <button mat-icon-button aria-label="Button to save add new Administrator." color="primary"
                    (click)="modifyAdministrator(undefined, true)"
                    matTooltip="Add Administrator to persistent storage." type="button">
              <mat-icon>person_add</mat-icon>
            </button>

            <!-- Lock Selected Administrators --
            <button mat-icon-button (click)="confirmLockAdministrators()"
                    aria-label="Button to lock the selected administrators."
                    matTooltip="Lock the selected administrators."
                    type="button">
              <mat-icon>lock</mat-icon>
            </button> -->

            <!-- Unlock Selected Administrators --
            <button mat-icon-button (click)="confirmUnlockAdministrators()"
                    aria-label="Button to unlock the selected administrators."
                    matTooltip="Unlock the selected administrators."
                    type="button">
              <mat-icon>lock_open</mat-icon>
            </button> -->

            <!-- Delete Selected Administrators --
            <button mat-icon-button (click)="confirmDeleteAdministrators()"
                    aria-label="Button to delete the selected administrators." color="warn"
                    matTooltip="Delete the selected administrators." type="button">
              <mat-icon>delete_sweep</mat-icon>
            </button> -->
          </th>
          <td mat-cell *matCellDef="let a" class="align-end">

            <!-- Modification -->
            <button mat-icon-button (click)="modifyAdministrator(a, false)"
                    [disabled]="currentAdministrator.emailAddress === a.emailAddress"
                    aria-label="Button to modify the administrator." matTooltip="Modify the administrator."
                    type="button">
              <mat-icon>edit_note</mat-icon>
            </button>

            <!-- Locking --
            <button mat-icon-button *ngIf="!a.locked"
                    [disabled]="currentAdministrator.emailAddress === a.emailAddress"
                    aria-label="Button to lock the administrator." matTooltip="Lock the administrator." type="button">
              <mat-icon>lock</mat-icon>
            </button>
            <button mat-icon-button *ngIf="a.locked"
                    [disabled]="currentAdministrator.emailAddress === a.emailAddress"
                    aria-label="Button to unlock the administrator." matTooltip="Unlock the administrator."
                    type="button">
              <mat-icon>lock_open</mat-icon>
            </button> -->

            <!-- Deletion --
            <button mat-icon-button (click)="confirmDeleteAdministrator(a)"
                    [disabled]="currentAdministrator.emailAddress === a.emailAddress"
                    aria-label="Button to delete the administrator." color="warn" matTooltip="Delete the administrator."
                    type="button">
              <mat-icon>delete</mat-icon>
            </button> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
